import { advanceSearch } from "../../_helper/services/advanceSearchv2"

export const currentProcessStatus = async (id) => {
    if (!id) return
    const payload = {
        "tableName": "LK_processstatus",
        "SearchParams": "[]",
        "columns": "*",
        "pageNumber": 1,
        "pageSize": 10000000,
        // "orderBy": "processid",
        // "sortBy": "",
        // "orderByMultiple": "",
        // "limit": 10000000000,
        "sortData": "Seq asc",
        "additionalWhere": `processid = ${id}`,
        location: "Benefits-global"
    }
    try {
        const response = await advanceSearch(payload, "Benefits")
        const { results } = response
        return results
        console.log(response, 'response1221')
    } catch (error) {

    }
}


export const HistoryLog = async (refId) => {
    if (!refId) return
    const payload = {
        "tableName": "vw_AduidtailBenefits_MASTER",
        "SearchParams": "",
        "columns": "*",
        "pageNumber": 1,
        "pageSize": 10000000,
        // "orderBy": "refid",
        // "sortBy": "",
        // "orderByMultiple": "",
        // "limit": 10000000000,
        "sortData": "",
        "additionalWhere": `refid = '${refId}'`,
        location: "global"
    }
    try {
        const response = await advanceSearch(payload)
        return response
        console.log(response, 'response1221')
    } catch (error) {

    }
}


export const getAuditTrail = async (HrControlNo) => {
    if (!HrControlNo) return
    const payload = {
        "tableName": "fn_GetProcessLogsBenefits",
        "SearchParams": JSON.stringify([{
            columnName: "HrControlNo",
            value: HrControlNo,
            operator: "=",
            dataType: "varchar(max)"
        }]),
        "columns": "*",
        "pageNumber": 1,
        "pageSize": 10000000,
        // "orderBy": "Dental_Hrcontrol",
        // "sortBy": "",
        // "orderByMultiple": "",
        // "limit": 10000000000,
        "sortData": "id asc",
        "additionalWhere": "",
        location: "Benefits-global"
    }
    try {
        const response = await advanceSearch(payload, "Benefits")
        const { results } = response;
        console.log(response, 'response1221');

        return results || [];
    } catch (error) {
        console.error('Error fetching audit trail:', error);
        return [];
    }
}

export const verifySSNDependent = async (ssn,type,subscriberID,dob,lastName) => {
    const payload = {
      tableName: "sp_verfiybyssn",
      SearchParams: JSON.stringify([
        {
          columnName: "ssn",
          value: ssn,
          operator: "=",
          dataType: "varchar(max)",
        },
        {
          columnName: "type",
          value: type,
          operator: "=",
          dataType: "varchar(max)",
        },
        {
          columnName: "subscriberID",
          value: subscriberID,
          operator: "=",
          dataType: "varchar(max)",
        },
        {
          columnName: "dob",
          value: dob,
          operator: "=",
          dataType: "varchar(max)",
        },
        {
          columnName: "lastName",
          value: lastName,
          operator: "=",
          dataType: "varchar(max)",
        },
      ]),
          "columns": "*",
          "pageNumber": 1,
          "pageSize": 10000000,
        //   "orderBy": "total",
        //   "sortBy": "",
        //   "orderByMultiple": "",
        //   "limit": 10000000000,
          "sortData": "",
          "additionalWhere": "",
          location: "Benefits-global"
      }
      try{
          const response = await advanceSearch(payload,"Benefits")
          const { results } = response
          return results
          console.log(response,'response1221')
      }catch(error){
  
      }
  }